import React from 'react';
import { useRecoilValue } from 'recoil';
import { freeShippingMinState } from '../../../utils/recoil/zone';
import { returnCurrencyCharFromCode } from '../../../utils/globals';

export const FreeShippingCaption = () => {
  const freeShippingMin = useRecoilValue(freeShippingMinState);
  return (
    <b>
      {`${freeShippingMin.value} ${returnCurrencyCharFromCode(
        process.env.GATSBY_CURRENCY
      )}`}
    </b>
  );
};
